module.exports = __webpack_public_path__ + "img/logo-footer.6d428089.svg";